<template>
  <div id="lm-leaflet-map">
    <l-map
      style="height: 100%; width: 100%"
      :zoom="zoom"
      :center="centerMapCoordinateComputed"
      :options="options"
    >
      <l-tile-layer :url="url"></l-tile-layer>
      <l-marker v-if="markerLatLng.length" :lat-lng="markerLatLng" ></l-marker>
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

export default {
  data () {
    return {
      url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
      defaultLocation: process.env.VUE_APP_DEFAULT_GEOLOCATION ? process.env.VUE_APP_DEFAULT_GEOLOCATION.split(',').map(i => parseFloat(i)) : [-34.6037389, -58.3815704]
    }
  },
  components: {
    'l-map': LMap,
    'l-tile-layer': LTileLayer,
    'l-marker': LMarker
  },
  props: {
    options: {
      type: Object,
      default: () => ({ scrollWheelZoom: false })
    },
    markerLatLng: {
      type: Array,
      default: () => []
    },
    centerMapCoordinate: {
      type: Array,
      default: () => this.defaultLocation
    },
    zoom: {
      type: Number,
      default: 16
    }
  },
  computed: {
    centerMapCoordinateComputed () {
      if (this.centerMapCoordinate.length) {
        return this.centerMapCoordinate
      } else {
        return this.defaultLocation
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#lm-leaflet-map
  height: 400px
</style>
